




















import { Component, Vue, Watch } from 'vue-property-decorator';
import { changeLoading } from '@/util/plugins';
const { VUE_APP_FCAPI: FCAPI } = process.env;
const getUrl = require('baimahu/url-with-param');
const API = {
  list: `${FCAPI}/shang/setting/account/profile`,
  detail: `${FCAPI}/shang/setting/account/profile/`,
  permission: `${FCAPI}/shang/setting/auth`,
  edit_permission: `${FCAPI}/shang/setting/account/profile/`,
};
@Component
export default class AccountSetting extends Vue {
  account_detail: any = {};
  is_loading: boolean = false;
  id: number = -1;
  name: any = '';
  permission_list: any = [];
  permission: any = [];
  back() {
    this.$router.go(-1);
  }

  @Watch('permission_list', { deep: true })
  permissionChange() {
    this.permission_list.forEach((item: any) => {
      item.indeterminate = item.checkedList.length !== item.type.length && item.checkedList.length !== 0;
      item.is_selected = item.checkedList.length === item.type.length;
    });
  }

  onChangeAll(item: any) {
    if (!item.is_selected) {
      item.checkedList = item.type;
    } else {
      item.checkedList = [];
    }
  }

  // 点击提交按钮
  @changeLoading(['is_loading'])
  async submit() {
    const id_arr: any = [];
    this.permission_list.forEach((item: any) => {
      if (item.checkedList.length > 0) {
        this.permission.forEach((item2: any) => {
          if (item.name === item2.name && item.checkedList.indexOf(item2.type) !== -1) {
            id_arr.push(item2.id);
          }
        });
      }
    });
    const res = await this.$axios.put(`${API.edit_permission}${this.id}`, {
      auth_set_list: id_arr.join(','),
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success('编辑成功');
  }

  // 获取账号权限详情
  @changeLoading(['is_loading'])
  async getAccountDetail() {
    const res = await this.$axios.get(`${API.detail}${this.id}`);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.account_detail = res.data.data;
  }

  // 获取权限列表
  @changeLoading(['is_loading'])
  async getPromissionList() {
    const res = await this.$axios.get(API.permission);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    const permission = res.data.data;
    this.permission = res.data.data;
    const permission_name_arr = [...new Set(permission.map((item: any) => item.name))];
    permission_name_arr.forEach((item: any) => {
      const obj: any = {
        name: item,
        type: [],
        checkedList: [],
        indeterminate: false,
        is_selected: false,
      };
      permission.forEach((item2: any) => {
        if (item2.name === item) {
          obj.type.push(item2.type);
        }
      });
      obj.type = [...new Set(obj.type)];
      this.permission_list.push(obj);
    });
  }

  async created() {
    this.id = +this.$route.query.id;
    this.name = this.$route.query.name;
    await this.getAccountDetail();
    await this.getPromissionList();
    const permission_arr = this.account_detail.auth_set_list.split(',').map((item: any) => +item);
    this.permission.forEach((item: any) => {
      if (permission_arr.indexOf(item.id) !== -1) {
        this.permission_list.forEach((item2: any) => {
          if (item2.name === item.name) {
            item2.checkedList.push(item.type);
          }
        });
      }
    });
  }
}
